import { useMemo, useState } from 'react';
import { dedupeTagsFromProducts } from '../utils/productCatalogTags';
import { buildProductTagSections } from '../utils/rankProductsByTags';

const allProductsSection = (products) => [{
  key: 'all',
  hits: 0,
  matchedTags: [],
  missingTags: [],
  isHero: true,
  isSingle: false,
  products: products || [],
}];

export function useProductTagFilter(products = []) {
  const [tagFilter, setTagFilter] = useState([]);

  const catalogTags = useMemo(() => dedupeTagsFromProducts(products), [products]);
  const resultSections = useMemo(() => {
    if (!tagFilter.length) return allProductsSection(products);
    return buildProductTagSections(products, tagFilter);
  }, [products, tagFilter]);
  const filteredProducts = useMemo(
    () => resultSections.flatMap((section) => section.products),
    [resultSections]
  );

  return { tagFilter, setTagFilter, catalogTags, filteredProducts, resultSections };
}
